import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import Input from '@vtex/styleguide/lib/Input'
import Button from '@vtex/styleguide/lib/Button'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import ModalTitle from '@/checkout-instore-legacy/components/Commons/ModalTitle'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import { buildChildId } from '@/checkout-instore-legacy/utils/TestUtils'
import {
  isValidDocument,
  maskDocument,
  unmaskDocument,
  handleDocumentInputMask,
  documentInputTypeForType,
} from '@/checkout-instore-legacy/utils/DocumentUtils'

class DocumentForReceipt extends Component {
  constructor(props) {
    super(props)

    const documentNumber = unmaskDocument({ documentNumber: props.document })
    const documentType = props.documentType
    const documentIsValid = isValidDocument({ documentNumber, documentType })

    this.state = {
      initialDocument: document,
      document: documentIsValid ? documentNumber : '',
      isValid: documentIsValid ? true : undefined,
    }
  }

  handleFormSubmit = (e) => {
    e.preventDefault()
    if (this.state.isValid) {
      this.props.setDocumentForReceipt(this.state.document, true)
      this.props.onSubmit()
    }
  }

  handleChange = (e) => {
    const newValue = unmaskDocument({ documentNumber: e.target.value })
    const isNewValueValid = isValidDocument({
      documentNumber: newValue,
      documentType: this.props.documentType,
    })
    this.setState({ document: newValue, isValid: isNewValueValid })
  }

  handleBlur = () => {
    const isValid = isValidDocument({
      documentNumber: this.state.document,
      documentType: this.props.documentType,
    })
    if (!isValid) {
      this.setState({
        isValid: this.state.document.length === 0 ? undefined : isValid,
      })
    }
  }

  static getDerivedStateFromProps(props, state) {
    const initialDocument = state.initialDocument
    const documentClean = unmaskDocument({ documentNumber: props.document })
    const documentPropIsInitialValue = initialDocument === documentClean
    const documentPropIsValid = isValidDocument({
      documentNumber: documentClean,
      documentType: props.documentType,
    })
      ? true
      : undefined

    return {
      initialDocument: documentClean,
      document: documentPropIsInitialValue ? state.document : documentClean,
      isValid: documentPropIsInitialValue ? state.isValid : documentPropIsValid,
    }
  }

  componentDidUpdate(_, prevState) {
    if (this.documentInput) {
      const { document } = this.state

      handleDocumentInputMask({
        documentType: this.props.documentType,
        prevInputValue: prevState.document,
        currentInputValue: document,
        inputRef: this.documentInput,
      })
    }
  }

  render() {
    const { mediaQuery, intl, documentType, id } = this.props
    const { isValid, document } = this.state

    const inputValue = maskDocument({ documentNumber: document, documentType })
    const inputId = buildChildId('value', id)

    const isDesktop = mediaQuery({
      phone: false,
      tablet: false,
      desktop: true,
    })

    return (
      <div id={this.props.id}>
        <ModalTitle id="cpfOnFiscalNote" />
        <form onSubmit={this.handleFormSubmit}>
          <Input
            id={inputId}
            type={documentInputTypeForType({ documentType })}
            className="f4 f3-ns"
            size="large"
            value={inputValue || ''}
            maxLength={this.props.mask.length}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            ref={(ref) => (this.documentInput = ref)}
            placeholder={this.props.placeholder}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            label={intl.formatMessage({ id: 'customerProfileDocumentType' })}
            errorMessage={
              isValid === false ? (
                <FormattedMessage
                  id="documentForReceiptInvalidDocument"
                  values={{ documentType }}
                />
              ) : null
            }
          />
          <div className="flex justify-end mt7">
            <Button
              id="cpfSubmit"
              disabled={!isValid}
              type="submit"
              variation="primary"
              block={!isDesktop}
            >
              <FormattedMessage id="documentForReceiptConfirm" />
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

DocumentForReceipt.propTypes = {
  id: PropTypes.string,
  document: PropTypes.string,
  documentType: PropTypes.string,
  mask: PropTypes.string,
  placeholder: PropTypes.string,
  onSubmit: PropTypes.func,
  intl: intlShape.isRequired,
  setDocumentForReceipt: PropTypes.func.isRequired,
  mediaQuery: PropTypes.func.isRequired,
}

export default injectIntl(withMediaQuery(DocumentForReceipt))
